import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import { Alerts, ButtonLoader } from "Components";
import useAuth from "Context/useAuth";
import { paths } from "Constant/paths";
import { Validator } from "Utils/validator";
import { encryptFun } from "Utils";

export default function Login() {
  const { t } = useTranslation();
  const { Login } = useAuth();

  const [loading, setLoading] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    isValid: true,
  });
  const [errMsg, setErrMsg] = useState({
    email: "",
    password: "",
    isValid: "",
  });

  const { email, password, isValid } = formData;

  const togglePassword = () => {
    setIsShowPassword((prev) => !prev);
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      isValid: true,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === "email") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.blank"),
        }));
      } else if (e.target.value && !Validator.email(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          email: "",
        }));
      }
    }
    if (e.target.name === "password") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          password: t("common.messages.error.common.password.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          password: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (email && Validator.email(email) && password) {
        resolve(true);
      } else {
        if (!email) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.blank"),
          }));
        } else if (email && !Validator.email(email)) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.inValid"),
          }));
        }

        if (!password) {
          setErrMsg((prev) => ({
            ...prev,
            password: t("common.messages.error.common.password.blank"),
          }));
        }

        resolve(false);
      }
    });
  };

  const onLogin = async (e) => {
    e.preventDefault();
    const validationStatus = await getValidation();
    if (validationStatus) {
      setLoading(true);
      const encryptedPassword = encryptFun(formData.password);
      const payload = {
        username: formData.email,
        password: `${encryptedPassword}`,
      };
      const response = await Login(payload);
      setLoading(false);
      if (response?.message === "Incorrect username or password") {
        setFormData((prev) => ({
          ...prev,
          isValid: false,
        }));
        setErrMsg((prev) => ({
          ...prev,
          isValid: t("common.messages.error.guest.login.incorrectCredentials"),
        }));
      } else if (
        response?.message ===
        "Your account has not been activated. Please register once again"
      ) {
        setFormData((prev) => ({
          ...prev,
          isValid: false,
        }));
        setErrMsg((prev) => ({
          ...prev,
          isValid: t("common.messages.error.guest.login.inactiveUser"),
        }));
      }
    }
  };

  return (
    <div className="px-lg-4 d-flex flex-column justify-content-center max-w-400 mx-auto login-box">
      <div className="mb-5">
        <h3 className="text-xl-4xl text-2xl font-semibold">
          {t("guest.login.title")}
        </h3>
        <div className="text-sm text-grey-600">
          {t("guest.login.info")}?{" "}
          <Link
            className="text-primary-500 text-decoration-none font-medium"
            to={paths.registration}
          >
            {t("common.button.signUp")}
          </Link>
        </div>
      </div>
      <div className="new-onbording-form">
        <form className="" onSubmit={onLogin}>
          <Row>
            <Col sm={12} xs={12}>
              <div className={`mb-4 ${errMsg.email ? "error" : ""}`}>
                <label htmlFor="login-email" className="form-label mb-1">
                  {t("common.label.email")}
                </label>
                <div className="position-relative">
                  <input
                    type="email"
                    className="form-control form-control-lg pr-10 rounded-lg"
                    id="login-email"
                    placeholder={t("common.placeHolder.email")}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <span className="border-start-0 position-absolute top-0 end-0 bottom-0 w-10 d-flex justify-content-center align-items-center text-grey-400 border-0 bg-transparent">
                    <i className="bx bx-at "></i>
                  </span>
                </div>
                {errMsg.email && <p className="error">{errMsg.email}</p>}
              </div>
            </Col>
            {/* <Col sm={12} xs={12}>
                      <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
                        <label className="text-sm font-medium">
                          Sign in as
                        </label>{" "}
                        <span className="d-inline-block px-3 py-1 text-sm font-medium text-primary-800 rounded bg-primary-50">
                          i@moghadam.pro
                        </span>
                      </div>
                    </Col> */}
            <Col sm={12} xs={12}>
              <div className={`mb-3 ${errMsg.password ? "error" : ""}`}>
                <label htmlFor="login-pw" className="form-label mb-1">
                  {t("common.label.password")}
                </label>
                <div className="position-relative">
                  <input
                    type={isShowPassword ? "text" : "password"}
                    className="form-control form-control-lg pr-10 rounded-lg"
                    id="login-pw"
                    placeholder={t("common.placeHolder.password")}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="border-start-0 position-absolute top-0 end-0 bottom-0 w-10 d-flex justify-content-center align-items-center text-grey-400 border-0 bg-transparent"
                    onClick={togglePassword}
                  >
                    <i
                      className={`bx ${
                        isShowPassword ? "bx-hide" : "bx-show-alt"
                      } `}
                    ></i>
                  </button>
                </div>
                {errMsg.password && <p className="error">{errMsg.password}</p>}
              </div>
            </Col>

            <Col sm={12} xs={12}>
              <div className="forgot-pw mb-3 py-3 text-sm d-flex flex-wrap align-items-center gap-2">
                {t("common.button.forgotPassword")}?
                <Link to="/forget-password" className="text-primary-500">
                  {t("common.button.cilckHere")}
                </Link>
              </div>
            </Col>

            <Col sm={12} xs={12}>
              {!isValid && <Alerts variant="danger" message={errMsg.isValid} />}
              <div className="d-grid">
                {!loading ? (
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg rounded-lg"
                  >
                    {t("common.button.signIn")}
                  </button>
                ) : (
                  <ButtonLoader />
                )}
              </div>
            </Col>
          </Row>

          <div className="text-center mt-5 text-sm">
            <span className="text-grey-400">
              By signing up to create an account I accept Company’s
              <br />
              <a
                href="#"
                className="text-decoration-none font-semibold text-grey-700"
              >
                Terms of use & Privacy Policy.
              </a>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}
